import React, {Component} from 'react';
import './App.css';
import './resetStates';

//import images
import cellRing from './img/wall_ring.png';



                                                        /* //////////////////////////
                                                            IMAGE SET HANDLE
                                                        //////////////////////////*/
                                                        /* Cycle through images */

    class Image extends Component{
    constructor(props){
        super(props);
        this.initState = {
            pointer: 0,
            imgs: props.imgs,
            countId: 0,
        }

        this.state = this.initState;

        this.handleClick = this.handleClick.bind(this);
    }



    handleClick(){
        const {length}=this.state.imgs;
        const {pointer}=this.state;
        const {countId}=this.state;
        /* Images changes to next, onClick */
        const newPointer = pointer === length -1 ? 0 : pointer + 1;
        this.setState({pointer: newPointer});       
    
       /* handle and change ID depending on current src */
       const restartCount = countId === length -1 ? 0: countId +1;
       this.setState({ countId: restartCount});


    const resetBtn = document.querySelector(".button");
      resetBtn.addEventListener("click", (e)=>
       {
           setTimeout(() => {
            e.preventDefault()
            if(pointer !== this.initState){
             this.setState(this.initState);
             console.log("reset");
         }
         });
           }, 1000); 
        }


    render() {

        const {pointer,imgs, countId} = this.state;
        return (
            <div className="symbolWrapper">
            <img src={imgs[pointer]} onClick={this.handleClick} className="image" id={countId} alt="symbol"/>
            <img src={cellRing} alt="symbol ring" className="ring"/>  
            </div>
                  
        )
    }   

    }



    export default Image;
